<template lang="pug">
section.services
  .head
    h2 {{ title }}
    p {{ subtitle }}
  .container-fluid.items.i_mt_10.d-none.d-md-block
    .row.justify-content-center
      .col-auto(v-for="(content, index) in contentList", :key="index")
        item(
          :title="content.area03_Content_Title",
          :img="content.area03_Content_icon",
          :content="content.area03_Content_SubTitle"
        )

  .container-fluid
    .container.i_mt_10
      .row.d-md-none.mobile
        .col-12.i_p_0
          swiper.swiper-container(:options="swiperOption", ref="mySwiper")
            swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
              v-for="(content, index) in contentList",
              :key="index"
            )
              item(
                :title="content.area03_Content_Title",
                :img="content.area03_Content_icon",
                :content="content.area03_Content_SubTitle"
              )

          svg-icon.swiper-prev.d-md-none(
            iconClass="arrow_left_mobile",
            className="icon",
            @click="prevClick"
          )

          svg-icon.swiper-next.d-md-none(
            iconClass="arrow_right_mobile",
            className="icon",
            @click="nextClick"
          )

  router-link.btn_square.btn_blue(
    v-if="false",
    tag="a",
    :to="{ name: 'CustomerServiceContactUs' }"
  ) 聯絡我們
</template>

<script>
import Item from "@/components/product/Intro/BusinessIntro/Services/Item";

export default {
  name: "Services",
  components: {
    item: Item,
  },
  props: {
    title: String,
    subtitle: String,
    contentList: Array,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 2,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/intro/business_intro_head";

.distribution {
  width: 100%;
}

img {
  @include size(100%, auto);
}

.swiper-next,
.swiper-prev {
  @include square(40px);
  cursor: pointer;
  color: $color_blue_btn;
  z-index: 1;
}

.swiper-next {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
}

.swiper-prev {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
}

@media (min-width: 992px) {
  .col-auto {
    padding-left: 0.65vw;
    padding-right: 0.65vw;
  }
}

@media (max-width: 575px) {
  .container {
    padding-left: 30px;
    padding-right: 30px;
  }

  .swiper-next,
  .swiper-prev {
    @include square(7vw);
  }
}
</style>
